import { gql } from '@apollo/client';

export const SPP_REPORTS_BY_PROGRAM_TYPE = gql`
  query SPPReportsByProgramType($year: Int!) {
    sppReportsByProgramType(year: $year) {
      ipp_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
      comfit_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
      maxcap_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
      community_solar_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
    }
  }
`;

export const SPP_REPORTS_ACCOUNTING_BY_PROGRAM_TYPE = gql`
  query SPPReportsAccountingByProgramType($year: Int!) {
    sppReportsAccountingByProgramType(year: $year) {
      ipp_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
      comfit_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
      maxcap_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
      community_solar_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
    }
  }
`;

export const SPP_REPORTS_PROD_STAT_NETGEN_BY_PROGRAM_TYPE = gql`
  query SPPReportsProdStatNetGenByProgramType($year: Int!) {
    sppReportsProdStatNetGenByProgramType(year: $year) {
      ipp_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
      comfit_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
      maxcap_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
      community_solar_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
      }
    }
  }
`;

export const SPP_REPORTS_POST_PROD_STAT_NETGEN_BY_PROGRAM_TYPE = gql`
  query SPPReportsPostProdStatNetGenByProgramType($year: Int!) {
    sppReportsPostProdStatNetGenByProgramType(year: $year) {
      ipp_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
        prod_stat_netgen {
          jan
          feb
          mar
          apr
          may
          jun
          jul
          aug
          sep
          oct
          nov
          dec
        }
      }
      comfit_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
        prod_stat_netgen {
          jan
          feb
          mar
          apr
          may
          jun
          jul
          aug
          sep
          oct
          nov
          dec
        }
      }
      maxcap_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
        prod_stat_netgen {
          jan
          feb
          mar
          apr
          may
          jun
          jul
          aug
          sep
          oct
          nov
          dec
        }
      }
      community_solar_meters {
        meter_id
        meter_number
        location
        company
        generation_type
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
        ytd_total
        prod_stat_netgen {
          jan
          feb
          mar
          apr
          may
          jun
          jul
          aug
          sep
          oct
          nov
          dec
        }
      }
    }
  }
`;
